import { Alert, Spinner } from "reactstrap";
import { useLoaderData, useOutlet, Await } from "react-router-dom";
import { AuthProvider } from "utilFunctions/CustomHooks/useAuth";
import { Suspense } from "react";
import ReloadIcon from "Assets/Icons/ReloadIcon";

export const AuthLayout = () => {
  const outlet = useOutlet();

  const { userPromise } = useLoaderData() as { userPromise: unknown };
  console.log("userPromise", userPromise);
  return (
    <Suspense fallback={<Spinner />}>
      <Await
        resolve={userPromise}
        errorElement={
          <Alert color="danger">
            Something Went Wrong !&nbsp;&nbsp;
            <a className="alert-link" href="/" rel="noreferrer" target="_blank">
              Reload page &nbsp;
              <ReloadIcon />
            </a>
          </Alert>
        }
      >
        {(user) => <AuthProvider userData={user}>{outlet}</AuthProvider>}
      </Await>
    </Suspense>
  );
};
